const getStudentFullname = student =>
  `${student.forename.trim()} ${student.surname.trim()}`.trim()

export default getStudentFullname
